import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PatientApi } from '@core/apis/patient/patient.api';
import { ContactAuthHelper } from '@core/helpers/contact-auth.helper';
import { InputPhoneEmailComponent } from '@core/components/input-phone-email/input-phone-email.component';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IResolvedContact } from '@core/interfaces/interface';

@Component({
  selector: 'app-restore',
  imports: [ReactiveFormsModule, TranslocoModule, RouterModule, InputPhoneEmailComponent],
  templateUrl: './restore.component.html',
  styleUrl: './restore.component.scss',
})
@UntilDestroy()
export class RestoreComponent {
  public restoreForm!: FormGroup;
  public success: boolean = false;
  public resolvedContact: IResolvedContact | null = null;
  constructor(
    private fb: FormBuilder,
    private readonly patientApi: PatientApi,
  ) {}

  ngOnInit(): void {
    this.reactiveForm();
  }

  private reactiveForm(): void {
    this.restoreForm = this.fb.group({
      contact: ['', [Validators.required, ContactAuthHelper.emailOrPhoneValidator()]],
    });
  }

  get contact(): FormControl {
    return this.restoreForm.get('contact') as FormControl;
  }

  get resolvedEmail(): string | null {
    return this.resolvedContact && 'email' in this.resolvedContact ? this.resolvedContact.email : null;
  }

  get resolvedPhone(): boolean {
    return !!(this.resolvedContact && 'phone' in this.resolvedContact);
  }

  public send(): void {
    this.resolvedContact = ContactAuthHelper.resolveContact(this.contact.value);
    if (this.resolvedContact && 'email' in this.resolvedContact)
      this.patientApi
        .emailPasswordRecovery(this.resolvedContact.email)
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          this.success = true;
        });
    else if (this.resolvedContact && 'phone' in this.resolvedContact)
      this.patientApi
        .phonePasswordRecovery(this.resolvedContact.phone)
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          this.success = true;
        });
  }
}
